<ng-container *transloco="let t; read: 'scheduler-shared'">
  <ng-container *ngIf="vm$ | async as vm">
  <ng-template #template let-anchor>
    <div>{{ anchor.nativeElement.getAttribute("data-description") }}</div>
  </ng-template>

  <div
    kendoTooltip
    [tooltipTemplate]="template"
    filter=".eventTitle"
  >
    <div class="demo-container">


      <div
        kendoDropTargetContainer
        dropTargetFilter=".drop-zone, td:has(.drop-zone)"
        (onDrop)="onDrop($event, scheduler)"
        (onDragEnter)="onDragEnter($event)"
        (onDragLeave)="onDragLeave($event)"
        #dropWrapper
      >
        <kendo-scheduler
          #scheduler
          [class.scheduler-readonly-dialog]="isReadonlyDialog"
          [workDayStart]="vm.tenantSettings.startMorningWorkTime"
          [workDayEnd]="vm.tenantSettings.endAfternoonWorkTime"
          [columnWidth]="60"
          [events]="schedulerEvents$ | async"
          [selectedDate]="selectedDate"
          [showWorkHours]="true"
          [resources]="resources"
          [group]="group"
          [weekStart]="weekStart"
          [workWeekStart]="Day.Monday"
          [workWeekEnd]="Day.Friday"
          [eventStyles]="setBorderColor"
          [slotClass]="setSlotBackgroundColor"
          (dateChange)="onDateChange($event)"
          (dragEnd)="onDragEnd($event)"
          (save)="saveHandler($event)"
          (cancel)="cancelHandler($event)"
          (remove)="removeHandler($event)"
          (slotDblClick)="slotDblClickHandler($event)"
          (eventDblClick)="eventDblClickHandler($event)"
          (dragEnd)="dragEndHandler($event)"
          (resizeEnd)="resizeEndHandler($event)"
          [selectedViewIndex]="vm.selectedViewIndex"
          (selectedViewIndexChange)="onViewChange($event, vm.tenantSettings)"
          (schedulerResize)="onSchedulerResize($event)"
          [loading]="isLoading"
          [editable]="isEditable"
        >
          <ng-template
            kendoSchedulerGroupHeaderTemplate
            let-resource="resource"
          >
            @if(!isMobileView){
            <span [style.color]="resource.color">{{ resource.text }}</span>
            <p class="ressourceDepartment" *ngIf="resource.department">
              {{ resource.department }}
            </p>
            }
            @else{
              {{ resource.shortText }}
            }
            
          </ng-template>

          <ng-template
            kendoSchedulerToolbarTemplate
            let-selectedDate="selectedDate"
            class="k-scheduler-toolbar"
            let-selectedView="selectedView"
          >
            <div kendoSchedulerToolbarNavigation></div>

            <div>KW {{ weekNumber }}</div>
            <div *ngIf="selectedView.name == 'timelineMonth'">
              - {{ weekNumberEnd }}
            </div>

            <button
              kendoButton
              (click)="toggleLock()"
              [svgIcon]="isLocked ? lockIcon : unlockIcon"
              [title]="isLocked ? 'Entsperren' : 'Sperren' "
              ></button> 

            <span class="k-spacer"></span>

            <div
              kendoSchedulerToolbarViewSelector
              [displayMode]="toolbarWidth < 960 ? 'compact' : 'default'"
              class="k-scheduler-views-wrapper"
            ></div>
          </ng-template>

          <kendo-scheduler-timeline-view
            [slotDivisions]="1"
            [slotDuration]="getSlotDuration('timeline')"
            [selectedShortDateFormat]="'d.M.y'"
            [workWeekStart]="1"
            [numberOfDays]="1"
          >
          </kendo-scheduler-timeline-view>

          <kendo-scheduler-timeline-week-view
            [slotDivisions]="1"
            [slotDuration]="getSlotDuration('timelineWeek')"
            [workWeekStart]="1"
          >
          </kendo-scheduler-timeline-week-view>

          <kendo-scheduler-timeline-month-view
            [slotDivisions]="1"
            [slotDuration]="getSlotDuration('timelineMonth')"
            [workWeekStart]="1"
          >
          </kendo-scheduler-timeline-month-view>

          <kendo-scheduler-messages
            [calendarToday]="t('calendarToday')"
            [today]="t('today')"
            [timelineViewTitle]="t('timelineViewTitle')"
            [timelineWeekViewTitle]="t('timelineWeekViewTitle')"
            [timelineMonthViewTitle]="t('timelineMonthViewTitle')"
            [showWorkDay]="t('showWorkDay')"
            [showFullDay]="t('showFullDay')"
            [nextTitle]="t('nextTitle')"
            [previousTitle]="t('previousTitle')"
            [deleteDialogTitle]="t('deleteDialogTitle')"
            [deleteConfirmation]="t('deleteConfirmation')"
            [cancel]="t('cancelButton')"
            [destroy]="t('destroyButton')"
          >
          </kendo-scheduler-messages>

          <ng-template
            kendoSchedulerAllDaySlotTemplate
            let-date="date"
            let-resources="resources"
          >
            <div class="drop-zone" style="height:100%">
              <div
                class="slotDate"
                [attr.allDay]="true"
                [attr.resourceId]="resources[0].value"
                [attr.slotDate]="date"
                style="visibility:hidden;"
              >
                {{ date }}
              </div>
            </div>
          </ng-template>

          <ng-template kendoSchedulerDateHeaderTemplate let-date="date">
            @if(vm.selectedViewIndex != 2){
              <strong>{{ date | date: "EEEEEE dd.MM." }}</strong>
            }
            @else {
              <strong>{{ date | date: "EEEEEE dd." }}</strong>
            }
          </ng-template>


          <ng-template
            kendoSchedulerTimeSlotTemplate
            let-date="date"
            let-resources="resources"
          >
            <div class="drop-zone">
              <div
                class="slotDate"
                [attr.allDay]="false"
                [attr.resourceId]="resources[0].id"
                [attr.slotDate]="date"
                style="visibility:hidden;"
              >
                {{ date }}
              </div>
            </div>
          </ng-template>

          <!-- <ng-template
            kendoSchedulerGroupHeaderTemplate
            let-resource="resource"
          >
            <span [style.color]="resource.color">{{ resource.text }}</span>
          </ng-template> -->

          <ng-template
            kendoSchedulerEventTemplate
            let-event="event"
            let-resources="resources"
          >
            <div class="schedulerItem">
              <div class="content">
                <div
                  [attr.data-description]="event.description"
                  class="eventTitle"
                >
                  <span>
                    <ng-container *ngIf="event.dataItem.assignment?.id">
                      {{ event.dataItem.assignment?.title }}
                      {{ event.dataItem.assignment?.internalNumber }}
                      {{ " | " }}
                    </ng-container>
                    {{ event.title }}
                  </span>
                </div>
              </div>
              <!-- Kendo 25 no longer renders the delete icon on events. An element with
                   class "k-event-delete" inside the event still triggers the (remove) event. -->
              @if (isEditable && isEditable.remove) {
                <span class="k-link k-event-delete" [title]="t('destroyButton')" aria-hidden="true">
                  <kendo-svg-icon [icon]="xIcon" size="small"></kendo-svg-icon>
                </span>
              }
            </div>
          </ng-template>

          <ng-template
            kendoSchedulerEditDialogTemplate
            let-event="event"
            let-formGroup="formGroup"
            let-isNew="isNew"
            let-editMode="editMode"
          >
            <div [class.readonly-dialog]="isReadonlyDialog">
            <kendo-formfield>
              <kendo-label text="Tätigkeit"></kendo-label>
              <kendo-dropdownlist
                [data]="timeEntryCategories$ | async"
                [formControl]="formGroup.get('timeEntryCategory')"
                id="schedulerItemType-input"
                textField="name"
                valueField="id"
                [valuePrimitive]="false"
              >
              </kendo-dropdownlist>
              <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
            </kendo-formfield>

            <kendo-formfield orientation="horizontal">
              <kendo-label text="Titel"></kendo-label>
              <input
                kendoTextBox
                id="title-input"
                placeholder="Titel"
                [formControl]="formGroup.get('title')"
              />
              <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label text="Beschreibung"></kendo-label>
              <input
                kendoTextBox
                id="description-input"
                placeholder="Beschreibung"
                [formControl]="formGroup.get('description')"
              />
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label text="Start"></kendo-label>
              <kendo-datepicker
                class="custom-picker"
                [formControl]="formGroup.get('start')"
                (blur)="validateStartEnd()"
                *ngIf="formGroup.controls.isAllDay.value"
              >
              </kendo-datepicker>
              <kendo-datetimepicker
                class="custom-picker"
                [formControl]="formGroup.get('start')"
                (blur)="validateStartEnd()"
                *ngIf="!formGroup.controls.isAllDay.value"
              >
              </kendo-datetimepicker>
              <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label text="Ende"></kendo-label>
              <kendo-datepicker
                class="custom-picker"
                [formControl]="formGroup.get('end')"
                (blur)="validateEndStart()"
                *ngIf="formGroup.controls.isAllDay.value"
              >
              </kendo-datepicker>
              <kendo-datetimepicker
                class="custom-picker"
                [formControl]="formGroup.get('end')"
                (blur)="validateEndStart()"
                *ngIf="!formGroup.controls.isAllDay.value"
              >
              </kendo-datetimepicker>
              <kendo-formerror>{{
                t("isRequiredFieldAndMustBeAfterStart")
              }}</kendo-formerror>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label text="Ganztägiger Eintrag"></kendo-label>
              <input
                type="checkbox"
                id="k-is-allday-chkbox"
                kendoCheckBox
                [formControl]="formGroup.get('isAllDay')"
              />
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label text="Ressourcen"></kendo-label>
              <kendo-multiselect
                [data]="schedulerRessources"
                [formControl]="formGroup.get('ressourceIds')"
                textField="name"
                valueField="id"
                valuePrimitive="true"
              >
              </kendo-multiselect>
              <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
            </kendo-formfield>

            <kendo-formfield *permissionIf="'Permissions.Assignments.Search'">
              <kendo-label text="Auftrag"></kendo-label>
              <app-assignment-combobox
                [valuePrimitive]="true"
                [formControl]="formGroup.get('assignmentId')"
              >
              </app-assignment-combobox>
            </kendo-formfield>
            </div>
          </ng-template>
        </kendo-scheduler>
      </div>

      <ng-template #hint>
        <div class="custom-hint">
          <div class="drop-indicator-icons">
            <kendo-svgicon
              *ngIf="isDropValid"
              [icon]="plusIcon"
            ></kendo-svgicon>
            <kendo-svgicon
              *ngIf="!isDropValid"
              [icon]="cancleIcon"
            ></kendo-svgicon>
          </div>
          <div class="inner-content">
            <kendo-svgicon
              *ngIf="isDropValid"
              [icon]="exportIcon"
            ></kendo-svgicon>
            <kendo-svgicon
              *ngIf="!isDropValid"
              [icon]="clockIcon"
            ></kendo-svgicon>
            {{ currentData.title }} | {{ currentData.customerName }}
          </div>
        </div>
      </ng-template>

      <div
        #dragWrapper
        kendoDragTargetContainer
        dragTargetFilter=".k-listview-item"
        [hint]="{ hintTemplate: hint }"
        (onDrag)="onDrag($event)"
        (onDragStart)="onDragStart($event)"
      >
          <app-assignment-list 
            *ngIf="showAssigmentList"
            [assigments]="vm.assigments"
          ></app-assignment-list>
        
      </div>

    </div>
  </div>
  </ng-container>
</ng-container>
